import React, { Component } from 'react';
import { IS_NATIVE } from '../utils/http';

/**
 * Error Boundary spécialement conçu pour capturer les erreurs
 * qui causeraient un crash de l'app native Android
 */
class AndroidErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('AndroidErrorBoundary caught error:', error);
    console.error('Error info:', errorInfo);
    this.setState({ errorInfo });
    
    // Log to backend for debugging (non-blocking)
    if (IS_NATIVE) {
      try {
        fetch('https://carewashgo.app/api/log-error', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            error: error?.toString(),
            stack: error?.stack,
            componentStack: errorInfo?.componentStack,
            platform: 'android',
            timestamp: new Date().toISOString()
          })
        }).catch(() => {}); // Ignore fetch errors
      } catch (e) {}
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-indigo-900 to-purple-900 flex items-center justify-center p-4">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 max-w-md w-full text-center border border-white/20">
            <div className="text-6xl mb-4">😔</div>
            <h2 className="text-xl font-bold text-white mb-2">
              Oups, quelque chose s'est mal passé
            </h2>
            <p className="text-gray-300 mb-6">
              L'application a rencontré une erreur. Veuillez réessayer.
            </p>
            
            <div className="space-y-3">
              <button
                onClick={this.handleRetry}
                className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-bold py-3 px-6 rounded-xl hover:scale-105 transition-transform"
              >
                🔄 Réessayer
              </button>
              
              <button
                onClick={() => window.location.reload()}
                className="w-full bg-white/20 text-white font-bold py-3 px-6 rounded-xl hover:bg-white/30 transition-colors"
              >
                🔃 Recharger l'application
              </button>
            </div>
            
            {/* Affichage de l'erreur pour diagnostic */}
            {this.state.error && (
              <div className="mt-6 text-left bg-red-900/30 rounded-lg p-3 text-xs text-red-200 overflow-auto max-h-40">
                <strong>Erreur:</strong>
                <pre className="whitespace-pre-wrap">{this.state.error.toString()}</pre>
                {this.state.error.stack && (
                  <pre className="whitespace-pre-wrap mt-2 text-red-300/70">{this.state.error.stack.split('\n').slice(0,5).join('\n')}</pre>
                )}
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AndroidErrorBoundary;
